import React from 'react'
import Translator from '../components/common/translate/Translator'
import {ErrorMessage} from 'formik'

function FormikErrorMessage(props: {name: string}) {
  return <ErrorMessage name={props.name} render={(key: any) => <Translator name={key} />} />
}

export default FormikErrorMessage
